import { Fragment } from "react";
import { Container } from "react-bootstrap";
import Menu from "../../modules/public/menu/menu";
import FooterPostup from "../../modules/public/footer/footer";
import style from "./MyExternalLetters.module.css";
import ExternalShipments from "./components/ExternalShipments";
import usePage from "../../hooks/usePage";

function MyExternalLetters() {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />
      <main className="flex-grow-1">
        {pageSliders}

        <Container className="rtl">
          <h4 className={style.titleStyleMyletter}>مرسولات خارجی من</h4>

          {pageText}

          <ExternalShipments />
        </Container>
      </main>

      {pageImage}

      <FooterPostup />
    </Fragment>
  );
}

export default MyExternalLetters;
